import React from "react";
import { Section, Reveal, Eyebrow, SectionTitle } from "./ui";
import { steps, topicChips } from "./data";

/** Short bridge between the problem and the product. */
export function Bridge() {
  return <Section id="punto-de-partida" className="bg-[#eef6ff]" data-id="element-33" data-mp="228melrwb85kp">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-34" data-mp="2271k229zwmmu">
        <Eyebrow data-id="element-35" data-mp="270e8abarirf2">Cómo se usa</Eyebrow>
        <SectionTitle data-id="element-36" data-mp="271fmupqzlw1j">
          En vez de improvisar una respuesta nueva cada vez, abrís la estrategia que necesitás.
        </SectionTitle>
        <p className="mt-4 text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-37" data-mp="2gwzbqs74vugs">
          Pequeños Pasos, Grandes Logros™ está organizado por situaciones reales, para consultar
          en el momento exacto en el que te está pasando.
        </p>
      </Reveal>

      <ol className="mt-7 grid gap-2.5 sm:mt-9 sm:grid-cols-3 sm:gap-4" data-id="element-38" data-mp="riuc7t9c6apx">
        {steps.map((s, i) => <Reveal key={s.title} delay={i * 0.06} data-id="element-39" data-mp="vk61fxoastxl" data-mpi={i}>
            <li className="flex h-full items-center gap-3 rounded-2xl bg-white p-4 text-left shadow-[0_14px_36px_-28px_rgba(23,50,77,0.6)] sm:flex-col sm:items-start sm:gap-0 sm:p-6" data-id="element-40" data-mp="vkxwn7dzgpnc">
              <span className="flex h-9 w-9 flex-none items-center justify-center rounded-xl bg-[var(--accent)] text-sm font-extrabold text-white sm:mb-4 sm:h-10 sm:w-10" data-id="element-41" data-mp="236evqbnoy9yu">
                {i + 1}
              </span>
              <div data-id="element-42" data-mp="1tatzku5b03x0">
                <p className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-[var(--accent)]" data-id="element-43" data-mp="1t763pocdz5f4">
                  {s.n}
                </p>
                <h3 className="mt-0.5 font-serif-display text-lg text-[var(--ink)]" data-id="element-44" data-mp="2lypupuf85nro">{s.title}</h3>
                <p className="mt-1 text-xs leading-snug text-[var(--muted)] sm:text-sm" data-id="element-45" data-mp="2gxk0tt9tvugk">{s.text}</p>
              </div>
            </li>
          </Reveal>)}
      </ol>

      <Reveal delay={0.1} data-id="element-46" data-mp="15jxzzaulw4f7">
        <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-47" data-mp="15khlt2ndncyi">
          {topicChips.map(c => <li key={c} className="rounded-full border border-[#d5e6f8] bg-white px-3.5 py-1.5 text-xs font-bold text-[var(--accent)]" data-id="element-48" data-mp="10jk40r6a4kxj">
              {c}
            </li>)}
        </ul>
      </Reveal>
    </Section>;
}